import * as tslib_1 from "tslib";
/**
 * The service to provide drag and drop functionality of job match cards.
 */
import * as CandidateJobMatchCardNotInterestedModalTemplate from 'raw-loader!src/app/public/app/partials/missioncontrol/candidateJobMatchesWorkflow/candidateJobMatchesWorkflow/candidateJobMatchCard/candidate-job-match-card-not-interested-modal.html';
import * as CandidateJobMatchCardReleasedModal from 'raw-loader!src/app/public/app/partials/missioncontrol/candidateJobMatchesWorkflow/candidateJobMatchesWorkflow/candidateJobMatchCard/candidate-job-match-card-released-modal.html';
import * as CandidateJobMatchCardMoveModalTemplate from 'raw-loader!src/app/public/app/partials/missioncontrol/candidateJobMatchesWorkflow/candidateJobMatchesWorkflow/candidateJobMatchCard/candidate-job-match-card-move-modal.html';
var JobMatchDragAndDropService = /** @class */ (function () {
    /*@ngInject*/
    function JobMatchDragAndDropService($uibModal) {
        this.$uibModal = $uibModal;
    }
    JobMatchDragAndDropService.prototype.getAllowedDraggableTypesOfCurrentWorkflowStep = function (currentWorkflowStep, enabledSteps) {
        var draggableTypes = [];
        if (currentWorkflowStep == "Released") {
            // draggableTypes = enabledSteps.filter(step => {
            //     return step !== "Release";
            // });
            draggableTypes = tslib_1.__spread(enabledSteps);
        }
        else if (currentWorkflowStep == "Not Interested") {
            // draggableTypes = enabledSteps.filter(step => {
            //     return step !== "Not Interested";
            // });
            draggableTypes = tslib_1.__spread(enabledSteps);
        }
        else {
            draggableTypes = this._getPreviousAndNextWorkflowSteps(enabledSteps, currentWorkflowStep);
        }
        return draggableTypes;
    };
    JobMatchDragAndDropService.prototype._getPreviousAndNextWorkflowSteps = function (enabledSteps, currentWorkflowStep) {
        var prevStepIndex = enabledSteps.indexOf(currentWorkflowStep) - 1;
        var prevWorkflowStep = prevStepIndex == -1 ? "" : enabledSteps[prevStepIndex];
        var nextStepIndex = enabledSteps.indexOf(currentWorkflowStep) + 1;
        var nextWorkflowStep = nextStepIndex == enabledSteps.length ? "" : enabledSteps[nextStepIndex];
        return [prevWorkflowStep, currentWorkflowStep, nextWorkflowStep, "Not Interested", "Released"];
    };
    JobMatchDragAndDropService.prototype.dropJobMatchCardToWorkflowStep = function (jobMatchToDrop, droppingToStep, enabledSteps, refreshCallback) {
        if (jobMatchToDrop.currentStep !== droppingToStep) {
            var actionToBeExecuted = this._getActionToBeExecutedOnDrop(jobMatchToDrop, droppingToStep, enabledSteps);
            if (actionToBeExecuted.length !== 0) {
                this._performActionOnDrop(actionToBeExecuted[0], jobMatchToDrop, refreshCallback);
            }
            else {
                var message = "This action is not allowed.";
                if (droppingToStep == "Released" || droppingToStep == "Not Interested" || this._isJobMatchMovedToNextStep(jobMatchToDrop.currentStep, droppingToStep, enabledSteps)) {
                    message = "This card cannot be moved to <span class='emerald'>'" + droppingToStep + "'</span> as it is in <span class='emerald'>'" + jobMatchToDrop.jobMatchCurrentState + "'</span> state.";
                }
                else {
                    message = "This card cannot be moved back to <span class='emerald'>'" + droppingToStep + "'</span> as it is in <span class='emerald'>'" + jobMatchToDrop.jobMatchCurrentState + "'</span> state.";
                }
                bootbox.alert({
                    closeButton: false,
                    title: "<div class='alert alert-warning' style='margin-bottom: 0px;'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>Action Not Allowed!</strong></div>",
                    message: message,
                    className: "zIndex1060",
                    buttons: {
                        ok: {
                            label: 'Ok',
                            className: 'btn-info'
                        }
                    }
                });
            }
        }
    };
    JobMatchDragAndDropService.prototype._getActionToBeExecutedOnDrop = function (jobMatchToDrop, droppingToStep, enabledWorkflowSteps) {
        var action = [];
        if (droppingToStep == "Not Interested") {
            action = jobMatchToDrop.availableActions.filter(function (action) {
                return action.actionType.includes("NOT_INTERESTED");
            });
            if (action.length > 0) {
                return action;
            }
        }
        if (droppingToStep == "Released") {
            action = jobMatchToDrop.availableActions.filter(function (action) {
                return action.actionType.includes("RELEASE");
            });
            if (action.length > 0) {
                return action;
            }
        }
        var indexOfDroppingToStep = enabledWorkflowSteps.indexOf(droppingToStep);
        var indexOfCandidateStep = enabledWorkflowSteps.indexOf(jobMatchToDrop.currentStep);
        //return move backward action
        if (indexOfDroppingToStep < indexOfCandidateStep) {
            action = jobMatchToDrop.availableActions.filter(function (action) {
                return action.actionType.includes('MOVE_BACKWARD');
            });
            if (action.length > 0) {
                return action;
            }
        }
        else {
            //return skip action
            action = jobMatchToDrop.availableActions.filter(function (action) {
                return action.actionType.includes('SKIP');
            });
            if (action.length > 0) {
                return action;
            }
            //return move forward action
            action = jobMatchToDrop.availableActions.filter(function (action) {
                return action.actionType.includes('MOVE_FORWARD');
            });
            if (action.length > 0) {
                return action;
            }
        }
        return action;
    };
    JobMatchDragAndDropService.prototype._performActionOnDrop = function (actionObject, jobMatchToDrop, refreshCallback) {
        if (!actionObject.allowed) {
            var message = _.isNull(actionObject.message) ? 'This action is not allowed.' : actionObject.message;
            bootbox.alert({
                closeButton: false,
                title: "<div class='alert alert-warning' style='margin-bottom: 0px;'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>Action Not Allowed!</strong></div>",
                message: message,
                className: "zIndex1060",
                buttons: {
                    ok: {
                        label: 'Ok',
                        className: 'btn-info'
                    }
                }
            });
        }
        else {
            var actionType = actionObject.actionType;
            var label = actionObject.action;
            switch (actionType) {
                case 'NOT_INTERESTED':
                case 'RELEASE':
                    this._launchNotInterestedOrReleasedModal(label, jobMatchToDrop, refreshCallback);
                    break;
                case 'MOVE_BACKWARD':
                case 'MOVE_FORWARD':
                case 'SKIP_RECRUITER_SCREENING':
                case 'SKIP_TECHNICAL_ASSESSMENT':
                case 'SKIP_VALUE_ASSESSMENT':
                case 'SKIP_PHONE_SCREEN':
                case 'SKIP_INTERVIEW':
                    this._setDataAndLaunchMoveJobMatchModal(actionType, label, jobMatchToDrop, refreshCallback);
                    break;
                default:
                //do nothing
            }
        }
    };
    JobMatchDragAndDropService.prototype._isJobMatchMovedToNextStep = function (currentStep, droppingToStep, enabledWorkflowSteps) {
        return enabledWorkflowSteps.indexOf(droppingToStep) > enabledWorkflowSteps.indexOf(currentStep);
    };
    JobMatchDragAndDropService.prototype._launchNotInterestedOrReleasedModal = function (modalType, jobMatchToDrop, refreshCallback) {
        var templateUrl = '';
        var statusType = '';
        var windowTopClass = 'four-dot-five-modal-large';
        switch (modalType) {
            case 'Not Interested':
                templateUrl = CandidateJobMatchCardNotInterestedModalTemplate.default;
                statusType = 'Not Interested';
                break;
            case 'Release':
                templateUrl = CandidateJobMatchCardReleasedModal.default;
                statusType = 'Release';
                break;
        }
        var setStatusModal = this.$uibModal.open({
            animation: true,
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            template: templateUrl,
            backdrop: 'static',
            keyboard: false,
            windowTopClass: windowTopClass,
            controller: ['$uibModalInstance', 'jobMatchDetailsArray', 'statusType', 'workflowStepName', 'saveCallback', function ($uibModalInstance, jobMatchDetailsArray, statusType, workflowStepName, saveCallback) {
                    var vm = this;
                    vm.jobMatchDetailsArray = jobMatchDetailsArray;
                    vm.statusType = statusType;
                    vm.workflowStepName = workflowStepName;
                    vm.saveCallback = function () {
                        $uibModalInstance.close('cancel');
                        saveCallback();
                    };
                    vm.closeModal = function () {
                        $uibModalInstance.close('cancel');
                    };
                }],
            controllerAs: 'setStatusModal',
            size: 'lg',
            resolve: {
                jobMatchDetailsArray: function () {
                    var tempArray = [];
                    var tempObject = {};
                    tempObject.jobMatchId = jobMatchToDrop.jobMatchId;
                    tempObject.candidateId = jobMatchToDrop.id;
                    tempObject.workflowStepName = jobMatchToDrop.currentStep;
                    tempArray.push(tempObject);
                    return tempArray;
                },
                statusType: function () {
                    return statusType;
                },
                workflowStepName: function () {
                    return jobMatchToDrop.currentStep;
                },
                saveCallback: function () {
                    return refreshCallback;
                }
            }
        });
    };
    JobMatchDragAndDropService.prototype._setDataAndLaunchMoveJobMatchModal = function (modalType, label, jobMatchToDrop, refreshCallback) {
        var templateUrl = '';
        var callbackType = '';
        var windowTopClass = 'four-dot-five-modal-medium';
        switch (modalType) {
            case 'MOVE_FORWARD':
            case 'MOVE_BACKWARD':
                templateUrl = CandidateJobMatchCardMoveModalTemplate.default;
                callbackType = 'refreshWorkflow';
                break;
            case 'SKIP_RECRUITER_SCREENING':
            case 'SKIP_TECHNICAL_ASSESSMENT':
            case 'SKIP_VALUE_ASSESSMENT':
            case 'SKIP_PHONE_SCREEN':
            case 'SKIP_INTERVIEW':
                templateUrl = CandidateJobMatchCardMoveModalTemplate.default;
                windowTopClass = 'four-dot-five-modal-small';
                break;
        }
        this._launchMoveActionModal(modalType, label, templateUrl, windowTopClass, callbackType, jobMatchToDrop, refreshCallback);
    };
    JobMatchDragAndDropService.prototype._launchMoveActionModal = function (modalType, label, templateUrl, windowTopClass, callbackType, jobMatchToDrop, refreshCallback) {
        var jobMatchIdModal = this.$uibModal.open({
            animation: true,
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            template: templateUrl,
            backdrop: 'static',
            keyboard: false,
            windowTopClass: windowTopClass,
            controller: ['$uibModalInstance', 'jobMatchId', 'candidateId', 'modalType', 'label', 'refreshCallback', function ($uibModalInstance, jobMatchId, candidateId, modalType, label, refreshCallback) {
                    var vm = this;
                    vm.jobMatchId = jobMatchId;
                    vm.candidateId = candidateId;
                    vm.modalType = modalType;
                    vm.label = label;
                    vm.moveType = 'Forward';
                    if (vm.modalType == 'MOVE_BACKWARD') {
                        vm.moveType = 'Backward';
                    }
                    else if (vm.modalType == "SKIP_RECRUITER_SCREENING" || vm.modalType == "SKIP_TECHNICAL_ASSESSMENT" || vm.modalType == "SKIP_VALUE_ASSESSMENT" || vm.modalType == "SKIP_PHONE_SCREEN" || vm.modalType == "SKIP_INTERVIEW") {
                        vm.moveType = 'Skip';
                    }
                    vm.closeModal = function () {
                        $uibModalInstance.close('cancel');
                    };
                    vm.closeModalAndRefresh = function () {
                        $uibModalInstance.close('cancel');
                        refreshCallback();
                    };
                    vm.saveCallback = function () {
                        $uibModalInstance.close('cancel');
                        refreshCallback();
                    };
                    vm.refreshCallback = function () {
                        refreshCallback();
                    };
                }],
            controllerAs: 'jobMatchIdModal',
            size: 'lg',
            resolve: {
                jobMatchId: function () {
                    return jobMatchToDrop.jobMatchId;
                },
                modalType: function () {
                    return modalType;
                },
                label: function () {
                    return label;
                },
                refreshCallback: function () {
                    return refreshCallback;
                },
                candidateId: function () {
                    return jobMatchToDrop.id;
                }
            }
        });
    };
    JobMatchDragAndDropService.prototype.isMoveBackActionFromNotInterestedOrReleasedStep = function (jobMatchToDrop) {
        var isValidAction = false;
        if (jobMatchToDrop.currentStep == "Not Interested" || jobMatchToDrop.currentStep == "Released") {
            var stepToDropTo = jobMatchToDrop.availableActions.filter(function (action) {
                return action.actionType == "MOVE_BACKWARD";
            });
            if (stepToDropTo.length > 0) {
                isValidAction = true;
            }
        }
        return isValidAction;
    };
    return JobMatchDragAndDropService;
}());
export { JobMatchDragAndDropService };
//# sourceMappingURL=jobMatchDragAndDropService.js.map